var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('Standards',{staticClass:"mb-2"}),_c('CouponStandards',{staticClass:"mb-2"}),_c('LegionellaStandards',{staticClass:"mb-2"})],1)}
var staticRenderFns = []

export { render, staticRenderFns }